import AppHeader from '../AppHeader'

//
// 新入社員 仮登録（F-NEW-01 / F-NEW-02）
//
// 事務員の役職ID（EmploymentContract::CLERK_USER_TYPE_ID と同じ値）
// 役職一覧の id は JSON:API の serializer が文字列で返すため文字列で持つ
const CLERK_USER_TYPE_ID = '350'

export default {
  name: 'onboarding-new',
  created () {
    if (!this.canRegister) {
      this.$router.push({ path: '/' })
      return
    }
    this.$store.dispatch('SHOP_ALL_GET', {})
    this.$store.dispatch('DOMAIN_LIST_SEARCH', {data: {}})
    // 役職は社員新規登録画面と同じ取得元（GET /master/users/new。権限1の役職は非表示になる）
    this.$store.dispatch('USER_NEW', {})
    this.loadShiftClasses()
  },
  data () {
    return {
      form: {
        user_name: '',
        user_firstname: '',
        user_name_furigana: '',
        user_firstname_furigana: '',
        email: '',
        user_domain_content: '',
        shop_id: window.localStorage.getItem('shop_id'),
        user_type_id: null,
        employment_pattern: 'full_time',
        shift_class_ids: []
      },
      joinDay: null,
      saving: false
    }
  },
  watch: {
    // 配属店舗を変えたらシフト区分の選択肢を引き直す
    'form.shop_id': function () {
      this.form.shift_class_ids = []
      this.loadShiftClasses()
    }
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    isHrManager () {
      return window.localStorage.getItem('user_authority') === '5'
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    // 本社採用担当（人事担当・人事管理責任者・システム管理者）は任意の店舗、
    // 権限区分が店舗管理者以上（2）・自店入力者（3）の人（店舗管理者フラグ・事務員も）は自店のみ
    canRegister () {
      return this.isSystemManagement || this.isHrManager || this.isHumanStaff ||
        this.isAppIncluding || this.isAppNotIncluded || this.isShopMaster || this.isClerk
    },
    // 配属店舗を自店に固定するか（本社採用担当・システム管理者以外。API 側でも自店に上書きされる）
    isShopFixed () {
      return !(this.isHumanStaff || this.isHrManager || this.isSystemManagement)
    },
    // パート（フリー／80）は配属店舗のシフト区分を選び、労働条件通知書の勤務欄に印字する
    isPartPattern () {
      return this.form.employment_pattern === 'part_free' || this.form.employment_pattern === 'part_80'
    },
    shiftClasses () {
      return this.$store.getters.onboardingShiftClasses || []
    },
    shops () {
      return this.$store.getters.shopsAll || []
    },
    // DOMAIN_LIST_SEARCH が埋めるのは domainList（domains は別モジュールの getter で常に空）
    domains () {
      return this.$store.getters.domainList || []
    },
    // USER_NEW が埋めるのは userTypes（社員新規登録画面と同じ action / getter の組み合わせ）
    userTypes () {
      return this.$store.getters.userTypes || []
    },
    // 事務員は役職 350（店舗事務員）に揃える（P2）ため、画面でも選択させない
    isClerkPattern () {
      return this.form.employment_pattern === 'clerk'
    },
    notify () {
      return this.$store.getters.onboardingNotify
    },
    // 既存の期限日入力と同じ yyyy-mm-dd 変換
    joinDayValue () {
      return this.joinDay ? this.joinDay.getFullYear() + '-' + ('0' + (this.joinDay.getMonth() + 1)).slice(-2) + '-' + ('0' + this.joinDay.getDate()).slice(-2) : ''
    }
  },
  components: {
    AppHeader
  },
  methods: {
    loadShiftClasses: function () {
      if (!this.form.shop_id) {
        return
      }
      this.$store.dispatch('GET_ONBOARDING_SHIFT_CLASSES', {data: {shop_id: this.form.shop_id}})
    },
    // 事務員を選んだら役職を 350（店舗事務員）に固定し、外したら選べるようにする
    selectedEmploymentPattern: function () {
      if (this.isClerkPattern) {
        this.form.user_type_id = this.clerkUserTypeId()
      } else if (String(this.form.user_type_id) === CLERK_USER_TYPE_ID) {
        this.form.user_type_id = null
      }
    },
    // 役職一覧の中の店舗事務員（350）。一覧に無ければ定数をそのまま使う
    clerkUserTypeId: function () {
      for (var i = 0; i < this.userTypes.length; i++) {
        if (String(this.userTypes[i].id) === CLERK_USER_TYPE_ID) {
          return this.userTypes[i].id
        }
      }
      return CLERK_USER_TYPE_ID
    },
    submit: function () {
      if (this.saving) {
        return
      }
      // ドメインが無いと招待メールを送れないため必須にする
      // 役職が無いと完了（本登録）後も社員管理に出てこないため必須にする
      if (!this.form.user_name || !this.form.email || !this.form.shop_id ||
          !this.form.user_domain_content || !this.form.user_type_id) {
        window.alert(this.$t('onboarding.message.required'))
        return
      }
      // パートは配属店舗にシフト区分があれば1つ以上必須（無い店舗は空欄で作成できる）
      if (this.isPartPattern && this.shiftClasses.length > 0 && this.form.shift_class_ids.length === 0) {
        window.alert(this.$t('onboarding.message.shift_classes_required'))
        return
      }
      var self = this
      this.saving = true
      var data = Object.assign({}, this.form, {user_joinday: this.joinDayValue})
      var callback = function (result) {
        self.saving = false
        self.$router.push({ path: '/onboarding/' + result.user_id })
      }
      this.$store.dispatch('CREATE_ONBOARDING_USER', {data: data, callback: callback})
      .then(() => { self.saving = false })
      .catch(() => { self.saving = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/onboarding-new.js